import React from 'react';

import { Segment, CppEstimator as Estimator } from 'components';

export default () => (
  <Segment style={{ minHeight: '100%' }}>
    <Estimator />
  </Segment>
);
